import { createContext } from 'react';

type NavigationBlockerCtx = boolean;

/**
 * Just to be able to check that we render the NavigationBlocker only once
 */
const NavigationBlockerContext = createContext<NavigationBlockerCtx>(false);

export default NavigationBlockerContext;
